module.exports = __webpack_public_path__ + "img/C户型.68744009.png";